




































































































































































































import api from '@/services/api';
import { Component, Vue } from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import { phoneValidator } from '@/services/inputTools';
import { IJobCorpsCenterControllerRequest, IJobCorpsCenterControllerResponse } from '@/classes/ControllerInterface/JobCorpsCenterController';

@Component
export default class CenterAdd extends Vue {
  public $refs!: {
    name: any
  };

  public jobCorpsCenter = new JobCorpsCenter();

  public disableButton: boolean = false;

  public checkDuplicateCenterName(): boolean {
    const centers: JobCorpsCenter[] = this.$store.getters.getJobCorpsCenters;
    const index: number = centers.findIndex((center: JobCorpsCenter) => center.name === this.jobCorpsCenter.name);
    return index >= 0;
  }

  public checkInputs(): string | boolean {
    const errors: string [] = [];
    if (this.jobCorpsCenter.phoneNumber !== undefined && this.jobCorpsCenter.phoneNumber !== null &&
        (phoneValidator(this.jobCorpsCenter.phoneNumber.toString()) === false)) {
        errors.push('Please enter a valid Phone Number.');
    }
    if (this.jobCorpsCenter.fax !== undefined && this.jobCorpsCenter.fax !== null && (phoneValidator(this.jobCorpsCenter.fax.toString()) === false)) {
        errors.push('Please enter a valid Fax.');
    }
    if (this.checkDuplicateCenterName()) {
      errors.push('Multiple Job Corps Centers with the same name cannot be created.');
      this.$refs.name.focus();
    }
    if (errors.length > 0) {
        return 'Please correct the following: \n\n' + errors.reduce((a: string, e: string) => a + '\n' + e );
    } else {
        return false;
    }
  }

  public sendForm() {
    if (this.checkInputs()) {
      alert(this.checkInputs());
    } else {
      this.disableButton = true;
      api().post('center/add', {center: this.jobCorpsCenter} as IJobCorpsCenterControllerRequest)
      .then((res) => {
        const response: IJobCorpsCenterControllerResponse | undefined = res.data;
        if (response && response.success && response.center && response.center.id) {
          this.$store.dispatch('loadCenters');
          alert('Success.');
          this.$router.push('/administration/center/profile/' + response.center.id);
        } else {
          if (response && response.message) {
            alert(response.message);
          } else {
            throw new Error();
          }
        }
      })
      .catch(() => {
        alert('Something went wrong.');
      })
      .finally(() => {
        this.disableButton = false;
      });
    }
  }
}
